import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';

/**
 * Check for an empty mix value
 * @param {Object|Array|number|string|null} value
 * @returns {boolean}
 */
const isEmptyField = value => {
  if (Number.isInteger(value)) {
    return false;
  }

  return isEmpty(value) || (isString(value) && isEmpty(value.trim()));
};

export default isEmptyField;
